import { lazy } from "react";
import {
  enumPermisosAval,
  enumPermisosAvalGestion,
  enumPermisosDale,
  enumPermisosRegistraduria,
  enumPermisosVentaSeguros
} from "./enumPermisosAval";

/** Componente de iconos */
const AppIcons = lazy(() => import("../../../components/Base/AppIcons"));

/**
 * Corresponsalia Grupo Aval
 */
const CorresponsaliaGrupoAval = lazy(() => import("./CorresponsaliaGrupoAval"));
// const AhorrosCorrienteGrupoAval = lazy(() =>
//  import(
//    "../apps/Corresponsalia/CorresponsaliaDavivienda/Views/AhorrosCorriente"
//  )
// );
const AdminGestionAval = lazy(() => import("./Views/AdminGestionAval"));
const DepositoGrupoAval = lazy(() =>
  import("./Views/AhorrosCorriente/Deposito")
);
const RetiroGrupoAval = lazy(() => import("./Views/AhorrosCorriente/Retiro"));
const RecaudoServiciosPublicosPrivadosMenuAval = lazy(() =>
  import("./Views/RecaudoServiciosPublicosPrivadosMenuAval")
);
const RecaudoServiciosPublicosPrivadosLecturaCodigoBarrasAval = lazy(() =>
  import(
    "./Views/RecaudoServiciosPublicosPrivados/RecaudoServiciosPublicosPrivadosLecturaCodigoBarrasAval"
  )
);
const SeleccionServicioPagarAval = lazy(() =>
  import("./Views/RecaudoServiciosPublicosPrivados/SeleccionServicioPagarAval")
);
const RecaudoServiciosPublicosPrivadosAval = lazy(() =>
  import(
    "./Views/RecaudoServiciosPublicosPrivados/RecaudoServiciosPublicosPrivadosAval"
  )
);
const ConveniosRecaudoAval = lazy(() =>
  import("./Views/RecaudoServiciosPublicosPrivados/ConveniosRecaudoAval")
);
const PagoTerceros = lazy(() => import("./Views/PagoTerceros/PagoTerceros"));
const PagoSubsidios = lazy(() => import("./Views/PagoSubsidios/PagoSubsidios"));
const AhorrosCorriente = lazy(() => import("./Views/AhorrosCorriente"));
const TransaccionRetiroDale = lazy(() =>
  import("./Views/Dale/TransaccionRetiroDale")
);
const MenuTransaccionesDaleAval = lazy(() =>
  import("./Views/Dale/MenuTransaccionesDaleAval")
);
const TransaccionDepositoDale = lazy(() =>
  import("./Views/Dale/TransaccionDepositoDale")
);

const PromocionDale = lazy(() => import("./Views/Dale/PromocionDale"));
const PromocionDalePublic = lazy(() =>
  import("./Views/Dale/PromocionDalePublic")
);
const listPermissions = Object.values(enumPermisosAval);
export const listPermissionsAval = listPermissions;
export const listPermissionsGestionAval = Object.values(
  enumPermisosAvalGestion
);
export const listPermissionsGrupoAvalDale = Object.values(enumPermisosDale);

const TramitesRegistraduria = lazy(() =>
  import("./Views/RegistraduriaTramites/TramitesRegistraduria")
);

export const listPermissionsRegistraduriaTramites = Object.values(
  enumPermisosRegistraduria
);

const VentaSeguros = lazy(() =>
  import("./Views/VentaSeguros/AceptacionPoliticaDatos")
);

const RecaudoVentaSegurosSura = lazy(() =>
  import("./Views/VentaSeguros/RecaudoSegurosSura")
);

export const listPermissionsVentaSeguros = Object.values(
  enumPermisosVentaSeguros
);

const rutasAvalCB = {
  link: "/corresponsalia/CorresponsaliaGrupoAval",
  label: <AppIcons Logo={"AVAL"} name="Corresponsalía Grupo Aval" />,
  component: CorresponsaliaGrupoAval,
  permission: listPermissionsAval,
  subRoutes: [
    {
      link: "/corresponsalia/CorresponsaliaGrupoAval/ahorrosCorriente",
      label: (
        <AppIcons
          Logo={"AVAL_TRANSACCIONES_CUENTAS"}
          name="Transacciones cuentas Grupo Aval"
        />
      ),
      component: AhorrosCorriente,
      permission: [
        enumPermisosAval.aval_cb_depositos,
        enumPermisosAval.aval_cb_retiros,
      ],
      subRoutes: [
        {
          link: "/corresponsalia/CorresponsaliaGrupoAval/ahorrosCorriente/deposito",
          label: <AppIcons Logo={"AVAL_DEPOSITO"} name="Depósitos" />,
          component: DepositoGrupoAval,
          permission: [enumPermisosAval.aval_cb_depositos],
        },
        {
          link: "/corresponsalia/CorresponsaliaGrupoAval/ahorrosCorriente/retiro",
          label: <AppIcons Logo={"AVAL_RETIROS"} name="Retiros" />,
          component: RetiroGrupoAval,
          permission: [enumPermisosAval.aval_cb_retiros],
        },
      ],
    },
    {
      link: "/corresponsalia/CorresponsaliaGrupoAval/recaudoServiciosPublicosPrivados",
      label: (
        <AppIcons
          Logo={"AVAL_RECAUDO_SERVICIOS_PUBLICOS_PRIVADOS"}
          name="Recaudo servicios públicos y privados"
        />
      ),
      component: RecaudoServiciosPublicosPrivadosMenuAval,
      permission: [enumPermisosAval.aval_cb_recaudo],
      subRoutes: [
        {
          link: "/corresponsalia/CorresponsaliaGrupoAval/recaudoServiciosPublicosPrivados/seleccion",
          label: (
            <AppIcons Logo={"AVAL_RECAUDO_MANUAL"} name="Recaudo manual" />
          ),
          component: SeleccionServicioPagarAval,
          permission: [enumPermisosAval.aval_cb_recaudo],
        },
        {
          link: "/corresponsalia/CorresponsaliaGrupoAval/recaudoServiciosPublicosPrivados/codbarras",
          label: (
            <AppIcons
              Logo={"AVAL_RECAUDO_CODIGO_DE_BARRAS"}
              name="Recaudo código de barras"
            />
          ),
          component: RecaudoServiciosPublicosPrivadosLecturaCodigoBarrasAval,
          permission: [enumPermisosAval.aval_cb_recaudo],
        },
        {
          link: "/corresponsalia/CorresponsaliaGrupoAval/recaudoServiciosPublicosPrivados/manual",
          label: <AppIcons Logo={"MARKETPLACE"} name="Recaudo manual" />,
          component: RecaudoServiciosPublicosPrivadosAval,
          permission: [enumPermisosAval.aval_cb_recaudo],
          show: false,
        },
      ],
    },
    {
      link: "/corresponsalia/CorresponsaliaGrupoAval/pagoterceros",
      label: (
        <AppIcons Logo={"AVAL_PAGO_DE_TERCEROS"} name="Pago de terceros" />
      ),
      component: PagoTerceros,
      permission: [enumPermisosAval.aval_cb_pago_terceros],
    },
    {
      link: "/corresponsalia/CorresponsaliaGrupoAval/pagosubsidios",
      label: (
        <AppIcons Logo={"AVAL_PAGO_DE_SUBSIDIOS"} name="Pago de subsidios" />
      ),
      component: PagoSubsidios,
      permission: [enumPermisosAval.aval_cb_pago_subsidios],
    },
  ],
};

export const rutasGestionGrupoAval = {
  link: "/GestionTransaccional/corresponsalia-grupo-aval",
  label: <AppIcons Logo={"AVAL_CONVENIO_RECAUDO"} name="Gestión Grupo Aval" />,
  component: AdminGestionAval,
  permission: [enumPermisosAvalGestion.aval_cb_convenios_recaudo],
  subRoutes: [
    {
      link: "/GestionTransaccional/corresponsalia-grupo-aval/convenios",
      label: (
        <AppIcons
          Logo={"AVAL_CONVENIO_RECAUDO"}
          name="Convenios recaudo AVAL"
        />
      ),
      component: ConveniosRecaudoAval,
      permission: [enumPermisosAvalGestion.aval_cb_convenios_recaudo],
    },
  ],
};

export const rutasDaleGrupoAval = {
  link: "/dale",
  label: <AppIcons Logo={"DALE"} name="Dale" />,
  component: MenuTransaccionesDaleAval,
  permission: [...listPermissionsGrupoAvalDale],
  subRoutes: [
    {
      link: "/dale/retiro",
      label: <AppIcons Logo={"RETIRO_DALE"} name="Retiro OTP" />,
      component: TransaccionRetiroDale,
      permission: [enumPermisosDale.RETIRO_OTP_DALE],
    },
    {
      link: "/dale/deposito",
      label: <AppIcons Logo={"DEPOSITO_DALE"} name="Depósito" />,
      component: TransaccionDepositoDale,
      permission: [enumPermisosDale.DEPOSITO_DALE],
    },
    {
      link: "/dale/promocion",
      label: <AppIcons Logo={"VENTA_DALE"} name="Venta Billetera Dale" />,
      component: PromocionDale,
      permission: [enumPermisosDale.PROMOCION_DALE],
    },
  ],
};

export const rutasDaleGrupoAvalPublic = {
  link: "/public/promocion-dale",
  label: <AppIcons Logo={"VENTA_DALE"} name="Promoción Dale" />,
  component: PromocionDalePublic,
};

export const rutasRegistraduriaTramitesAval = {
  link: "/registraduria-tramites",
  label: <AppIcons Logo={"REGISTRADURIA"} name="Trámites Registraduría" />,
  component: TramitesRegistraduria,
  permission: [...listPermissionsRegistraduriaTramites],
  subRoutes: [],
};

export const rutasVentaSegurosAval = {
  link: "/venta-seguros",
  label: (
    <AppIcons
      Logo={"VENTA_SEGUROS_SURA"}
      name="Venta de seguros"
    />
  ),
  component: VentaSeguros,
  permission: [...listPermissionsVentaSeguros],
  subRoutes: [
    {
      link: "/venta-seguros/recaudo-sura",
      label: <AppIcons Logo={"VENTA_SEGUROS_SURA"} name="Recaudo Seguro Sura" />,
      component: RecaudoVentaSegurosSura,
      permission: [enumPermisosVentaSeguros.RECAUDO_VENTA_SEGUROS_SURA],
      show: false,
    }
  ],
};

export default rutasAvalCB;
